import {AnyAction} from 'redux';

import * as at from './file_action_types';
import {DocumentConfig} from 'src/js/model/document_config';
import {File} from 'src/js/model/file';

const defaultState = {
  cachedFiles: {},
  currentFile: new File(),
  resultDetailConfig: new DocumentConfig(),
  resultDetailProjectConfig: new DocumentConfig(),
  tablesConfig: {},
  isLoadingCounter: 0,
};

function reducer(state = defaultState, action: AnyAction) {
  switch (action.type) {
    case at.CHANGE_FILE: {
      return {...state, currentFile: action.payload};
    }
    case at.CLOSE_FILE: {
      return {...state, currentFile: defaultState.currentFile};
    }
    case at.FILE_FETCH: {
      return {
        ...state,
        isLoadingCounter: state.isLoadingCounter + 1,
      };
    }
    case at.FILE_FETCH_FAILURE: {
      return {
        ...state,
        currentFile: defaultState.currentFile,
        isLoadingCounter: Math.max(state.isLoadingCounter - 1, 0),
      };
    }
    case at.FILE_FETCH_SUCCESS: {
      const {file, fileId} = action.payload;
      return {
        ...state,
        currentFile: file,
        isLoadingCounter: Math.max(state.isLoadingCounter - 1, 0),
        cachedFiles: {...state.cachedFiles, [fileId]: file},
      };
    }
    case at.SET_RESULT_DETAIL_CONFIG: {
      const {config, reload} = action.payload;
      if (reload || (config && !state.resultDetailConfig.isLoaded())) {
        return {...state, resultDetailConfig: config};
      }
      break;
    }
    case at.SET_RESULT_DETAIL_PROJECT_CONFIG: {
      const {config, reload} = action.payload;
      if (reload || (config && !state.resultDetailProjectConfig.isLoaded())) {
        return {...state, resultDetailProjectConfig: config};
      }
      break;
    }
    case at.SET_TABLE_CONFIG: {
      const {config, reload} = action.payload;
      const tableConfig = state.tablesConfig[config.getId()];
      if (reload || !tableConfig || (tableConfig && !tableConfig.isLoaded())) {
        return {
          ...state,
          tablesConfig: {...state.tablesConfig, [config.getId()]: config},
        };
      }
      break;
    }
  }
  return state;
}

export default reducer;
